import { Endpoint, api } from "../data/api";
import { Transaction } from "../domain";

export function getTransactions(accountId: number) {
  return api.post(Endpoint.getTransactions, { accountId })
    .then(items => items.map(item => Transaction.fromDb(item)));
}